import axios from 'axios';

const API = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 20000,
});

// Har bir so'rovga token qo'shish
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.includes('/auth/login')) {
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login') {
        sessionStorage.setItem('returnAfterLogin', `${window.location.pathname}${window.location.search}`);
        window.location.assign('/login');
      }
    }
    if (error.response?.status === 428 && error.response?.data?.code === 'PASSWORD_CHANGE_REQUIRED'
      && !error.config?.url?.includes('/auth/change-password')) {
      if (window.location.pathname !== '/change-password') window.location.assign('/change-password');
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (data) => API.post('/auth/login', data);
export const getMe = () => API.get('/auth/me');
export const changeMyPassword = (data) => API.put('/auth/change-password', data);

// Dashboard
export const getDashboard = () => API.get('/dashboard');

// Bo'limlar
export const getDepartments = (params) => API.get('/departments', { params });
export const createDepartment = (data) => API.post('/departments', data);
export const updateDepartment = (id, data) => API.put(`/departments/${id}`, data);
export const deleteDepartment = (id) => API.delete(`/departments/${id}`);

// Tovarlar
export const getItems = (params) => API.get('/items', { params });
export const getItemGroups = () => API.get('/items/groups');
export const createItem = (data) => API.post('/items', data);
export const updateItem = (id, data) => API.put(`/items/${id}`, data);
export const getItemHistory = (id) => API.get(`/items/${id}/history`);
export const deleteItem = (id) => API.delete(`/items/${id}`);
export const getStockBalance = () => API.get('/items/balance');

// Kirim
export const stockIn = (data) => API.post('/stock/in', data);
export const getStockIn = () => API.get('/stock/in');
export const getStockInDetail = (id) => API.get(`/stock/in/${id}`);
export const updateStockIn = (id, data) => API.put(`/stock/in/${id}`, data);
export const confirmStockIn = (id) => API.put(`/stock/in/${id}/confirm`);
export const rejectStockIn = (id, data) => API.put(`/stock/in/${id}/reject`, data);
export const getWarehouses = () => API.get('/stock/warehouses');
export const getSuppliers = () => API.get('/suppliers');
export const createSupplier = (data) => API.post('/suppliers', data);

// Chiqim
export const getStockOut = () => API.get('/stock/out');

// So'rovlar
export const getRequests = () => API.get('/requests');
export const getRequestDetail = (id) => API.get(`/requests/${id}`);
export const createRequest = (data) => API.post('/requests', data);
export const approveRequest = (id, data) => API.put(`/requests/${id}/approve`, data);
export const rejectRequest = (id, data) => API.put(`/requests/${id}/reject`, data);
export const prorectorApprove = (id, data) => API.put(`/requests/${id}/prorector-approve`, data);
export const prorectorReject = (id, data) => API.put(`/requests/${id}/prorector-reject`, data);
export const markOutOfStock = (id, data) => API.put(`/requests/${id}/out-of-stock`, data);
export const cancelRequestItem = (requestId, itemId, data) => API.put(`/requests/${requestId}/items/${itemId}/cancel`, data);
export const acceptRequestReceipt = (id) => API.put(`/requests/${id}/accept-receipt`);
export const rejectRequestReceipt = (id, data) => API.put(`/requests/${id}/reject-receipt`, data);
export const counterOffer = (id, data) => API.put(`/requests/${id}/counter-offer`, data);
export const acceptCounter = (id) => API.put(`/requests/${id}/accept-counter`);
export const rejectCounter = (id, data) => API.put(`/requests/${id}/reject-counter`, data);

// Yangi tovar xatlari (item requests)
export const getItemRequests = () => API.get('/item-requests');
export const getItemRequest = (id) => API.get(`/item-requests/${id}`);
export const createItemRequest = (data) => API.post('/item-requests', data);
export const approveItemRequest = (id, data) => API.put(`/item-requests/${id}/approve`, data);
export const rejectItemRequest = (id, data) => API.put(`/item-requests/${id}/reject`, data);
export const approveItemRequestFinance = (id, data) => API.put(`/item-requests/${id}/finance-approve`, data);
export const rejectItemRequestFinance = (id, data) => API.put(`/item-requests/${id}/finance-reject`, data);
export const startItemProcurement = (id, data) => API.put(`/item-requests/${id}/start-procurement`, data);
export const markItemRequestPurchased = (id, data) => API.put(`/item-requests/${id}/mark-purchased`, data);
export const confirmItemRequestAccounting = (id, data) => API.put(`/item-requests/${id}/accounting-confirm`, data);
export const rejectItemRequestAccounting = (id, data) => API.put(`/item-requests/${id}/accounting-reject`, data);
export const receiveRequestedItem = (id, data) => API.post(`/item-requests/${id}/receive`, data);

// Sozlamalar
export const getSettings = () => API.get('/settings');
export const updateSettings = (data) => API.put('/settings', data);

// Hisobotlar
export const downloadReport = (type, format, params) =>
  API.get(`/reports/${type}/${format}`, { params, responseType: 'blob' });
export const previewReport = (type, params) => API.get(`/reports/preview/${type}`, { params });

// Foydalanuvchilar
export const getUsers = () => API.get('/users');
export const getUserOptions = () => API.get('/users/options/list');
export const createUser = (data) => API.post('/users', data);
export const updateUser = (id, data) => API.put(`/users/${id}`, data);
export const checkUserOffboarding = (id) => API.get(`/users/${id}/offboarding-check`);
export const resetUserPassword = (id, data) => API.put(`/users/${id}/reset-password`, data);
export const deleteUser = (id) => API.delete(`/users/${id}`);
export const getUserHistory = (id) => API.get(`/users/${id}/history`);

// Rahbar monitoringi
export const getAnalytics = (params) => API.get('/analytics/overview', { params });

// Individual inventar/aktivlar
export const getAssets = (params) => API.get('/assets', { params });
export const getAssetCatalog = (params) => API.get('/assets/catalog', { params });
export const getAssetSummary = () => API.get('/assets/summary');
export const getPendingUzasboAssets = () => API.get('/assets/uzasbo/pending');
export const linkUzasboAssets = (data) => API.put('/assets/uzasbo/link', data);
export const getAssetHistory = (id) => API.get(`/assets/${id}/history`);
export const createAsset = (data) => API.post('/assets', data);
export const createAssetBatch = (data) => API.post('/assets/batch', data);
export const getAssetQr = (id) => API.get(`/assets/${id}/qr`, { params: { app_origin: window.location.origin } });
export const getAssetByTag = (assetTag) => API.get(`/assets/scan/${encodeURIComponent(assetTag)}`);
export const auditAsset = (id, data) => API.put(`/assets/${id}/audit`, data);
export const checkoutAsset = (id, data) => API.put(`/assets/${id}/checkout`, data);
export const checkinAsset = (id, data) => API.put(`/assets/${id}/checkin`, data);
export const updateAssetStatus = (id, data) => API.put(`/assets/${id}/status`, data);
export const getMyAssetAssignments = () => API.get('/assets/assignments/mine');
export const acceptAssetAssignment = (id) => API.put(`/assets/assignments/${id}/accept`);
export const rejectAssetAssignment = (id, data) => API.put(`/assets/assignments/${id}/reject`, data);

// Aktivni bosqichli hisobdan chiqarish
export const getAssetWriteoffs = (params) => API.get('/asset-writeoffs', { params });
export const getAssetWriteoff = (id) => API.get(`/asset-writeoffs/${id}`);
export const getAssetWriteoffSummary = () => API.get('/asset-writeoffs/summary');
export const getEligibleWriteoffAssets = () => API.get('/asset-writeoffs/eligible-assets');
export const createAssetWriteoff = (data) => API.post('/asset-writeoffs', data);
export const resubmitAssetWriteoff = (id, data) => API.put(`/asset-writeoffs/${id}/resubmit`, data);
export const cancelAssetWriteoff = (id, data) => API.put(`/asset-writeoffs/${id}/cancel`, data);
export const reviewAssetWriteoff = (id, data) => API.put(`/asset-writeoffs/${id}/operator-review`, data);
export const decideAssetWriteoff = (id, data) => API.put(`/asset-writeoffs/${id}/commission-decision`, data);
export const decideAssetWriteoffAsLeader = (id, data) => API.put(`/asset-writeoffs/${id}/leader-decision`, data);
export const executeAssetWriteoff = (id, data) => API.put(`/asset-writeoffs/${id}/execute`, data);
export const completeAssetWriteoffAccounting = (id, data) => API.put(`/asset-writeoffs/${id}/accounting-complete`, data);
export const getAssetWriteoffEvidence = (id, evidenceId) => API.get(
  `/asset-writeoffs/${id}/evidence/${evidenceId}`,
  { responseType: 'blob' }
);

// Fizik sanoq
export const getInventoryCounts = (params) => API.get('/inventory-counts', { params });
export const getInventoryCount = (id) => API.get(`/inventory-counts/${id}`);
export const createInventoryCount = (data) => API.post('/inventory-counts', data);
export const approveInventoryCount = (id) => API.put(`/inventory-counts/${id}/approve`);
export const rejectInventoryCount = (id, data) => API.put(`/inventory-counts/${id}/reject`, data);

export default API;
